<script>
import { CREATE_NOTIFICATION, GET_NOTIFICATIONS } from '@/services/api/notification/general'
import Multiselect from 'vue-multiselect'
import { Helper } from '@/mixin/helper'
import { mapGetters } from 'vuex'
import McBadge from '@/components/McBadge'
import McButton from '@/components/McButton'
import { EventBus } from '@/router/views/fleet-task/lib/event-bus'

export default {
  name: 'PopUp',
  components: {
    Multiselect,
    McBadge,
    McButton,
  },
  mixins: [Helper],
  apollo: {
    notifications: {
      query: GET_NOTIFICATIONS,
      variables() {
        return {
          filter: {
            userId: this.getUserId(),
          },
        }
      },
      fetchPolicy: 'no-cache',
      manual: true,
      result({ data, loading }) {
        if (loading) {
          return
        }

        let notifications = data.notifications.notifications
          .filter((item) => item.byPush)
          .map((item) => item.alertCode)

        // set switch status in driver behavior section
        this.cekNonaktifDriverBehavior.acceleration = notifications.some((r) =>
          this.notificationsIds.acceleration.includes(r)
        )
        this.cekNonaktifDriverBehavior.deceleration = notifications.some((r) =>
          this.notificationsIds.deceleration.includes(r)
        )
        this.cekNonaktifDriverBehavior.speed = notifications.some((r) =>
          this.notificationsIds.speed.includes(r)
        )
        this.cekNonaktifDriverBehavior.turn = notifications.some((r) =>
          this.notificationsIds.turn.includes(r)
        )

        // set switch status in DMS section
        this.cekNonaktifDms.yawn = notifications.some((r) => this.notificationsIds.yawn.includes(r))
        this.cekNonaktifDms.distraction = notifications.some((r) =>
          this.notificationsIds.distraction.includes(r)
        )
        this.cekNonaktifDms.smoking = notifications.some((r) =>
          this.notificationsIds.smoking.includes(r)
        )
        this.cekNonaktifDms.phoneCalling = notifications.some((r) =>
          this.notificationsIds.phoneCalling.includes(r)
        )
        this.cekNonaktifDms.eyeClosed = notifications.some((r) =>
          this.notificationsIds.eyeClosed.includes(r)
        )
        this.cekNonaktifDms.missingFace = notifications.some((r) =>
          this.notificationsIds.missingFace.includes(r)
        )
        this.cekNonaktifDms.crash = notifications.some((r) =>
          this.notificationsIds.crash.includes(r)
        )
        this.cekNonaktifDms.seatbelt = notifications.some((r) =>
          this.notificationsIds.seatbelt.includes(r)
        )
        this.cekNonaktifDms.fatigueDriving = notifications.some((r) =>
          this.notificationsIds.fatigueDriving.includes(r)
        )
        this.cekNonaktifDms.infraredBlocked = notifications.some((r) =>
          this.notificationsIds.infraredBlocked.includes(r)
        )

        // set switch status in general section
        this.cekNonaktifGeneral.buttonSos = notifications.some((r) =>
          this.notificationsIds.buttonSos.includes(r)
        )
        this.cekNonaktifGeneral.disarm = notifications.some((r) =>
          this.notificationsIds.disarm.includes(r)
        )
        this.cekNonaktifGeneral.temperature = notifications.some((r) =>
          this.notificationsIds.temperature.includes(r)
        )
        this.cekNonaktifGeneral.battery = notifications.some((r) =>
          this.notificationsIds.battery.includes(r)
        )
        this.cekNonaktifGeneral.signal = notifications.some((r) =>
          this.notificationsIds.signal.includes(r)
        )
        this.cekNonaktifGeneral.vibration = notifications.some((r) =>
          this.notificationsIds.vibration.includes(r)
        )
        this.cekNonaktifGeneral.engine = notifications.some((r) =>
          this.notificationsIds.engine.includes(r)
        )
        this.cekNonaktifGeneral.geolocation = notifications.some((r) =>
          this.notificationsIds.geolocation.includes(r)
        )
        this.cekNonaktifGeneral.fuel = notifications.some((r) =>
          this.notificationsIds.fuel.includes(r)
        )
        this.cekNonaktifGeneral.pto = notifications.some((r) =>
          this.notificationsIds.pto.includes(r)
        )
        this.cekNonaktifGeneral.door1 = notifications.some((r) =>
          this.notificationsIds.door1.includes(r)
        )
        this.cekNonaktifGeneral.door2 = notifications.some((r) =>
          this.notificationsIds.door2.includes(r)
        )
        this.cekNonaktifGeneral.missRoute = notifications.some((r) =>
          this.notificationsIds.missRoute.includes(r)
        )
        this.cekNonaktifGeneral.idle = notifications.some((r) =>
          this.notificationsIds.idle.includes(r)
        )
        this.cekNonaktifGeneral.parking = notifications.some((r) =>
          this.notificationsIds.parking.includes(r)
        )
        this.cekNonaktifGeneral.coveredRemove = notifications.some((r) =>
          this.notificationsIds.coveredRemove.includes(r)
        )
        this.cekNonaktifGeneral.refrigerator = notifications.some((r) =>
          this.notificationsIds.refrigerator.includes(r)
        )
        this.cekNonaktifGeneral.excessiveStopInsideGeofence = notifications.some((r) =>
          this.notificationsIds.excessiveStopInsideGeofence.includes(r)
        )
        this.cekNonaktifGeneral.crashDetection = notifications.some((r) =>
          this.notificationsIds.crashDetection.includes(r)
        )
        this.cekNonaktifGeneral.drivingTime = notifications.some((r) =>
          this.notificationsIds.drivingTime.includes(r)
        )
        this.cekNonaktifGeneral.offlineVehicle = notifications.some((r) =>
          this.notificationsIds.offlineVehicle.includes(r)
        )

        // set switch status in ADAS section
        this.cekNonaktifAdas.forwardCollison = notifications.some((r) =>
          this.notificationsIds.forwardCollison.includes(r)
        )
        this.cekNonaktifAdas.laneDeparture = notifications.some((r) =>
          this.notificationsIds.laneDeparture.includes(r)
        )
        this.cekNonaktifAdas.headwayMonitor = notifications.some((r) =>
          this.notificationsIds.headwayMonitor.includes(r)
        )
        this.cekNonaktifAdas.frontObjectDetected = notifications.some((r) =>
          this.notificationsIds.frontObjectDetected.includes(r)
        )

        // set sound switch status in driver behavior section
        Object.keys(this.cekNonaktifDriverBehavior).forEach((key) => {
          if (key != 'all') {
            this.cekNonaktifSoundDriverBehavior[key] =
              this.cekNonaktifDriverBehavior[key] &&
              data.notifications.notifications
                .filter((item) => this.notificationsIds[key].includes(item.alertCode))
                .some((item) => item.sound)
          }
        })

        // set sound switch status in general section
        Object.keys(this.cekNonaktifGeneral).forEach((key) => {
          if (key != 'all') {
            this.cekNonaktifSoundGeneral[key] =
              this.cekNonaktifGeneral[key] &&
              data.notifications.notifications
                .filter((item) => this.notificationsIds[key].includes(item.alertCode))
                .some((item) => item.sound)
          }
        })

        // set sound switch status in DMS section
        Object.keys(this.cekNonaktifDms).forEach((key) => {
          if (key != 'all') {
            this.cekNonaktifSoundDms[key] =
              this.cekNonaktifDms[key] &&
              data.notifications.notifications
                .filter((item) => this.notificationsIds[key].includes(item.alertCode))
                .some((item) => item.sound)
          }
        })

        // set sound switch status in ADAS section
        Object.keys(this.cekNonaktifAdas).forEach((key) => {
          if (key != 'all') {
            this.cekNonaktifSoundAdas[key] =
              this.cekNonaktifAdas[key] &&
              data.notifications.notifications
                .filter((item) => this.notificationsIds[key].includes(item.alertCode))
                .some((item) => item.sound)
          }
        })
      },
    },
  },
  props: {
    status: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      phaseOneShow: false,
      cekNonaktifDriverBehavior: {
        all: true,
        acceleration: true,
        deceleration: true,
        speed: true,
        turn: true,
      },
      cekNonaktifDms: {
        all: true,
        yawn: true,
        distraction: true,
        smoking: true,
        phoneCalling: true,
        eyeClosed: true,
        missingFace: true,
        crash: true,
        seatbelt: true,
        fatigueDriving: true,
        infraredBlocked: true,
      },
      cekNonaktifGeneral: {
        all: true,
        buttonSos: true,
        disarm: true,
        temperature: true,
        battery: true,
        signal: true,
        vibration: true,
        engine: true,
        geolocation: true,
        fuel: true,
        pto: true,
        door1: true,
        door2: true,
        missRoute: true,
        idle: true,
        parking: true,
        coveredRemove: true,
        refrigerator: true,
        excessiveStopInsideGeofence: true,
        crashDetection: true,
        drivingTime: true,
        offlineVehicle: true,
      },
      cekNonaktifSoundDriverBehavior: {
        all: true,
        acceleration: true,
        deceleration: true,
        speed: true,
        turn: true,
      },
      cekNonaktifSoundDms: {
        all: true,
        yawn: true,
        distraction: true,
        smoking: true,
        phoneCalling: true,
        eyeClosed: true,
        missingFace: true,
        crash: true,
        seatbelt: true,
        fatigueDriving: true,
        infraredBlocked: true,
      },
      cekNonaktifSoundGeneral: {
        all: true,
        buttonSos: true,
        disarm: true,
        temperature: true,
        battery: true,
        signal: true,
        vibration: true,
        engine: true,
        geolocation: true,
        fuel: true,
        pto: true,
        door1: true,
        door2: true,
        missRoute: true,
        idle: true,
        parking: true,
        coveredRemove: true,
        refrigerator: true,
        crashDetection: true,
        drivingTime: true,
        offlineVehicle: true,
      },
      cekNonaktifAdas: {
        all: true,
        forwardCollison: true,
        laneDeparture: true,
        headwayMonitor: true,
        frontObjectDetected: true,
      },
      cekNonaktifSoundAdas: {
        all: true,
        forwardCollison: true,
        laneDeparture: true,
        headwayMonitor: true,
        frontObjectDetected: true,
      },
      popupDurationModel: {},
      hasChanged: false,
    }
  },
  computed: {
    isCheckAllDriverBehavior() {
      let self = this
      let isChecked = true
      Object.keys(this.cekNonaktifDriverBehavior).forEach(function (key) {
        if (key !== 'all' && !self.cekNonaktifDriverBehavior[key]) {
          isChecked = false
        }
      })

      return isChecked
    },
    isCheckAllDms() {
      let self = this
      let isChecked = true
      Object.keys(this.cekNonaktifDms).forEach(function (key) {
        if (key !== 'all' && !self.cekNonaktifDms[key]) {
          isChecked = false
        }
      })

      return isChecked
    },
    isCheckAllGeneral() {
      let self = this
      let isChecked = true
      Object.keys(this.cekNonaktifGeneral).forEach(function (key) {
        if (key !== 'all' && !self.cekNonaktifGeneral[key]) {
          isChecked = false
        }
      })

      return isChecked
    },

    isCheckAllAdas() {
      let self = this
      let isChecked = true
      Object.keys(this.cekNonaktifAdas).forEach(function (key) {
        if (key !== 'all' && !self.cekNonaktifAdas[key]) {
          isChecked = false
        }
      })

      return isChecked
    },
    popupDuration() {
      return { key: 5, label: `5 ${this.$t('global.time.seconds')}` }
    },
    popupDurationOptions() {
      return [
        { key: 5, label: `5 ${this.$t('global.time.seconds')}` },
        { key: 10, label: `10 ${this.$t('global.time.seconds')}` },
        { key: 15, label: `15 ${this.$t('global.time.seconds')}` },
      ]
    },
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
      hasAccessAll: 'identity/hasAccessAll',
      isNewSubmodule: 'identity/isNewSubmodule',
    }),
    notificationsIds() {
      return {
        acceleration: [24],
        deceleration: [23],
        speed: [8],
        turn: [25],
        yawn: [53],
        distraction: [52],
        smoking: [54],
        phoneCalling: [55],
        eyeClosed: [51],
        missingFace: [56],
        crash: [49],
        buttonSos: [11],
        disarm: this.hasAccess(['notif_tamper_alert:read']) ? [1, 37] : [1],
        temperature: [17, 18],
        battery: [2],
        signal: [3],
        vibration: [10],
        engine: [12],
        geolocation: [7],
        fuel: [13, 14],
        pto: [62, 63],
        door1: [4, 19],
        door2: [5, 20],
        missRoute: [75],
        idle: [15],
        parking: [16],
        coveredRemove: [36],
        refrigerator: [21, 22],
        forwardCollison: [90],
        laneDeparture: [92],
        headwayMonitor: [91],
        seatbelt: [110],
        excessiveStopInsideGeofence: [104],
        crashDetection: [94, 95],
        fatigueDriving: [50],
        drivingTime: [117],
        infraredBlocked: [111],
        frontObjectDetected: [113],
        offlineVehicle: [118],
      }
    },
    listGeneral() {
      let general = [
        {
          title: this.$t('global.alert.sosButton'),
          model: 'buttonSos',
          modelSound: 'buttonSos',
          scope: null,
        },
        {
          title: this.$t('global.alert.gpsDisarmed'),
          model: 'disarm',
          modelSound: 'disarm',
          scope: null,
        },
        {
          title: this.$t('global.alert.temperature'),
          model: 'temperature',
          modelSound: 'temperature',
          scope: this.hasAccess(['z1b-itemp:read']),
        },
        {
          title: this.$t('global.alert.lowBattery'),
          model: 'battery',
          modelSound: 'battery',
          scope: null,
        },
        {
          title: this.$t('global.alert.gpsWeakSignal'),
          model: 'signal',
          modelSound: 'signal',
          scope: null,
        },
        {
          title: this.$t('global.alert.vibration'),
          model: 'vibration',
          modelSound: 'vibration',
          scope: null,
        },
        {
          title: this.$t('notification.field.machineOn/Off'),
          model: 'engine',
          modelSound: 'engine',
          scope: null,
        },
        {
          title: this.$t('global.alert.geofence'),
          model: 'geolocation',
          modelSound: 'geolocation',
          scope: null,
        },
        {
          title: this.$t('global.alert.fuel'),
          model: 'fuel',
          modelSound: 'fuel',
          scope: this.hasAccess(['z1d-fuelultrasonic:read', 'z1e-itank:read']),
        },
        {
          title: this.$t('global.alert.pto'),
          model: 'pto',
          modelSound: 'pto',
          scope: this.hasAccess(['z1l-pto:read']),
        },
        {
          title: this.$t('global.alert.door1'),
          model: 'door1',
          modelSound: 'door1',
          scope: this.hasAccess(['z1f-idoor:read']),
        },
        {
          title: this.$t('global.alert.door2'),
          model: 'door2',
          modelSound: 'door2',
          scope: this.hasAccess(['z1f-idoor:read']),
        },
        {
          title: this.$t('global.alert.missRoute'),
          model: 'missRoute',
          modelSound: 'missRoute',
          scope: this.hasAccess(['d7a-default-md-route:read']),
        },
        {
          title: this.$t('global.alert.idleTime'),
          model: 'idle',
          modelSound: 'idle',
          scope: this.hasAccess(['notif_idle_parking:read']),
        },
        {
          title: this.$t('global.alert.parkTime'),
          model: 'parking',
          modelSound: 'parking',
          scope: this.hasAccess(['notif_idle_parking:read']),
        },
        {
          title: this.$t('global.alert.coverRemoved'),
          model: 'coveredRemove',
          modelSound: 'coveredRemove',
          scope: this.hasAccess(['notif_covered_remove:read']),
        },
        {
          title: this.$t('global.alert.refrigerator'),
          model: 'refrigerator',
          modelSound: 'refrigerator',
          scope: this.hasAccess(['notif_refrigerator:read']),
        },
        {
          title: this.$t('global.alert.excessiveStopInsideGeofence'),
          model: 'excessiveStopInsideGeofence',
          modelSound: 'excessiveStopInsideGeofence',
          scope: this.hasAccess(['e1f-web-excessivestopinsidegeofence:read']),
        },
        {
          title: this.$t('global.alert.crashDetection'),
          model: 'crashDetection',
          modelSound: 'crashDetection',
          scope: this.hasAccess(['teltonika-device:read']),
        },
        {
          title: this.$t('notification.alert.drivingTime'),
          model: 'drivingTime',
          modelSound: 'drivingTime',
          scope: null,
        },
        {
          title: this.$t('notification.alert.deviceOffline'),
          model: 'offlineVehicle',
          modelSound: 'offlineVehicle',
          scope: null,
        },
      ]
      general.sort((a, b) => {
        let x = a.title.toLowerCase()
        let y = b.title.toLowerCase()
        if (x < y) {
          return -1
        }
        if (x > y) {
          return 1
        }
        return 0
      })
      return general
    },
    listAdas() {
      let adas = [
        {
          title: this.$t('global.alert.forwardCollison'),
          model: 'forwardCollison',
          modelSound: 'forwardCollison',
          scope: null,
        },
        {
          title: this.$t('global.alert.laneDeparture'),
          model: 'laneDeparture',
          modelSound: 'laneDeparture',
          scope: null,
        },
        {
          title: this.$t('global.alert.headwayMonitor'),
          model: 'headwayMonitor',
          modelSound: 'headwayMonitor',
          scope: null,
        },
        {
          title: this.$t('global.alert.frontObjectDetected'),
          model: 'frontObjectDetected',
          modelSound: 'frontObjectDetected',
          scope: this.hasAccess(['front_object_detected_alert:read']),
        },
      ]
      adas.sort((a, b) => {
        let x = a.title.toLowerCase()
        let y = b.title.toLowerCase()
        if (x < y) {
          return -1
        }
        if (x > y) {
          return 1
        }
        return 0
      })
      return adas
    },
    illustrationPath() {
      return require('@/assets/images/illustration/saas/no-notification.png')
    },
  },

  mounted() {
    this.$apollo.queries.notifications.refetch()
    let currentConfig = JSON.parse(localStorage.getItem('notification-popup'))
    if (currentConfig !== undefined) {
      this.popupDurationModel = currentConfig.time
    }
  },

  methods: {
    checkSoundValueDriverBehavior(key) {
      if (key != 'all' && !this.cekNonaktifDriverBehavior[key]) {
        this.cekNonaktifSoundDriverBehavior[key] = false
      } else if (key != 'all' && this.cekNonaktifDriverBehavior[key]) {
        this.cekNonaktifSoundDriverBehavior[key] = true
      }
      this.toSave()
    },

    checkSoundValueDms(key) {
      if (key != 'all' && !this.cekNonaktifDms[key]) {
        this.cekNonaktifSoundDms[key] = false
      } else if (key != 'all' && this.cekNonaktifDms[key]) {
        this.cekNonaktifSoundDms[key] = true
      }
      this.toSave()
    },

    checkSoundValueGeneral(key) {
      if (key != 'all' && !this.cekNonaktifGeneral[key]) {
        this.cekNonaktifSoundGeneral[key] = false
      } else if (key != 'all' && this.cekNonaktifGeneral[key]) {
        this.cekNonaktifSoundGeneral[key] = true
      }

      this.toSave()
    },

    checkSoundValueAdas(key) {
      if (key != 'all' && !this.cekNonaktifAdas[key]) {
        this.cekNonaktifSoundAdas[key] = false
      } else if (key != 'all' && this.cekNonaktifAdas[key]) {
        this.cekNonaktifSoundAdas[key] = true
      }
      this.toSave()
    },

    checkAllDriverBehavior(event) {
      this.cekNonaktifDriverBehavior.all = event
      let obj = this.cekNonaktifDriverBehavior
      let objSound = this.cekNonaktifSoundDriverBehavior
      Object.keys(obj).forEach(function (key) {
        if (key !== 'all') {
          obj[key] = event
        }
      })
      Object.keys(objSound).forEach(function (key) {
        if (key !== 'all') {
          objSound[key] = event
        }
      })
      this.cekNonaktifDriverBehavior = obj
      this.cekNonaktifSoundDriverBehavior = objSound

      this.toSave()
    },

    checkAllDms(event) {
      this.cekNonaktifDms.all = event
      let obj = this.cekNonaktifDms
      let objSound = this.cekNonaktifSoundDms
      Object.keys(obj).forEach(function (key) {
        if (key !== 'all') {
          obj[key] = event
        }
      })
      Object.keys(objSound).forEach(function (key) {
        if (key !== 'all') {
          objSound[key] = event
        }
      })
      this.cekNonaktifDms = obj
      this.cekNonaktifSoundDms = objSound
      this.toSave()
    },

    checkAllGeneral(event) {
      this.cekNonaktifGeneral.all = event
      let obj = this.cekNonaktifGeneral
      let objSound = this.cekNonaktifSoundGeneral
      Object.keys(obj).forEach(function (key) {
        if (key !== 'all') {
          obj[key] = event
        }
      })
      Object.keys(objSound).forEach(function (key) {
        if (key !== 'all') {
          objSound[key] = event
        }
      })
      this.cekNonaktifGeneral = obj
      this.cekNonaktifSoundGeneral = objSound
      this.toSave()
    },

    checkAllAdas(event) {
      this.cekNonaktifAdas.all = event
      let obj = this.cekNonaktifAdas
      let objSound = this.cekNonaktifSoundAdas
      Object.keys(obj).forEach(function (key) {
        if (key !== 'all') {
          obj[key] = event
        }
      })
      Object.keys(objSound).forEach(function (key) {
        if (key !== 'all') {
          objSound[key] = event
        }
      })
      this.cekNonaktifAdas = obj
      this.cekNonaktifSoundAdas = objSound
      this.toSave()
    },

    setToDefault() {
      this.popupDurationModel = { key: 5, label: `5 ${this.$t('global.time.seconds')}` }
      this.checkAllDriverBehavior(false)
      this.checkAllDms(false)
      this.checkAllGeneral(false)
      this.checkAllAdas(false)
    },

    changeState(field, value) {
      this[field] = value

      setTimeout(() => {
        this.toSave()
      }, 500)
    },

    toSave() {
      const driverBehaviorIds = this.getNotificationIds(this.cekNonaktifDriverBehavior)

      const dmsIds = this.getNotificationIds(this.cekNonaktifDms)

      const generalIds = this.getNotificationIds(this.cekNonaktifGeneral)

      const adasIds = this.getNotificationIds(this.cekNonaktifAdas)

      const driverBehaviorSoundIds = this.getNotificationIds(this.cekNonaktifSoundDriverBehavior)

      const dmsSoundIds = this.getNotificationIds(this.cekNonaktifSoundDms)

      const generaSoundlIds = this.getNotificationIds(this.cekNonaktifSoundGeneral)

      const adasSoundIds = this.getNotificationIds(this.cekNonaktifSoundAdas)

      const alertCodes = driverBehaviorIds.concat(generalIds).concat(dmsIds).concat(adasIds)
      const alertSounds = driverBehaviorSoundIds
        .concat(generaSoundlIds)
        .concat(dmsSoundIds)
        .concat(adasSoundIds)

      let input = {
        alertCode: alertCodes,
      }

      if (this.hasAccess(['sound_notification:update'])) {
        input = {
          ...input,
          alertSound: alertSounds,
        }
      }

      const self = this
      this.$apollo
        .mutate({
          mutation: CREATE_NOTIFICATION,
          variables: {
            input,
          },
        })
        .then((res) => {
          let data = res.data.createNotification
          if (data.isSuccessful) {
            localStorage.setItem(
              'notification-popup',
              JSON.stringify({
                time: self.popupDurationModel,
                alertCodes: alertCodes,
                alertSounds: alertSounds,
              })
            )

            this.$store.commit('notification/configPopUp', {
              time: self.popupDurationModel,
              alertCodes: alertCodes,
              alertSounds: alertSounds,
            })

            self.$mcToast.success(this.$t('global.alert.text.popupConfigurationSaved'))
            this.$apollo.queries.notifications.refetch()
            this.hasChanged = false
          } else {
            self.$mcToast.warning(data.message)
          }
        })
    },

    getNotificationIds(data) {
      let ids = []
      let notifications = this.notificationsIds
      Object.keys(data).forEach(function (key) {
        if (key !== 'all' && data[key]) {
          ids.push(...notifications[key])
        }
      })

      return ids
    },
    setStatus() {
      this.$store.commit('notification/SET_STATUS', this.status)
    },
    showOnboarding() {
      EventBus.$emit('show-onboarding')
    },
  },
}
</script>

<template>
  <b-tab active class="border-0" @click="setStatus">
    <template #title>
      <span class="d-sm-inline-block">{{ $t('notification.object.popUpNotification') }}</span>
      <span v-if="isNewSubmodule('e2a-popup-notifikasi')" class="float-end">
        <McBadge variant="danger" size="small" type="notif" class="mx-1" />
      </span>
    </template>

    <div class="mc-notification">
      <div
        v-if="hasAccessAll(['alert_rule_template:read', 'alert_rule_template:create'])"
        class="col-md-4 col-sm-12 mt-4"
      >
        <div class="border border-1 p-3 rounded">
          <div class="d-flex align-items-center">
            <img
              :src="illustrationPath"
              class="me-2"
              alt="Recommendation Notification"
              style="width: 80px"
            />
            <div>
              <h5>{{ $t('notification.onboarding.notSure') }}</h5>
              <span class="text-muted d-block">
                {{ $t('notification.onboarding.checkRecommendation') }}
              </span>
              <McButton
                :text="$t('notification.onboarding.seeRecommendation')"
                size="sm"
                class="mt-2"
                @click="showOnboarding"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 mt-4">
        <h5 class="card-title">
          {{ $t('notification.title.popUpNotification') }}
        </h5>
      </div>
      <div class="border border-1 p-3 rounded">
        <div class="row d-flex flex-row">
          <div class="col-md-6 mt-3">
            <h6>{{ $t('notification.object.popUpDuration') }}</h6>
            <span>{{ $t('notification.text.popUpDuration') }}</span>
          </div>
          <div class="col-md-6 d-flex justify-content-end my-3 align-self-center">
            <div class="col-md-4 me-2">
              <multiselect
                v-model="popupDurationModel"
                :options="popupDurationOptions"
                track-by="key"
                label="label"
                :placeholder="$t('notification.object.popUpDuration')"
                @input="hasChanged = true"
              />
            </div>
            <McButton
              v-if="hasChanged"
              variant="primary"
              icon="icon-outline_save"
              :text="$t('global.save')"
              class="me-2"
              @click="toSave"
            />
            <McButton
              variant="secondary"
              icon="icon-fill_refresh"
              :text="$t('global.default')"
              @click="setToDefault"
            />
          </div>
        </div>
      </div>

      <div
        v-if="
          hasAccessAll([
            'raw_alerts_driver:read',
            'e1a-web-perilakupengemudi:read',
            'e2a-popup-notifikasi:create',
            'e2a-popup-notifikasi:read',
          ])
        "
        class="row"
      >
        <div class="col-md-6 mt-4">
          <h5 class="card-title">
            {{ $t('global.object.driverBehavior') }}
          </h5>
        </div>
        <div class="col-md-6 align-self-end">
          <div class="float-end mt-4">
            <h6
              v-if="!isCheckAllDriverBehavior"
              class="text-primary"
              @click="checkAllDriverBehavior(true)"
            >
              {{ $t('global.action.activate') }}
            </h6>
            <h6 v-else class="text-primary" @click="checkAllDriverBehavior(false)">
              {{ $t('global.action.nonactivate') }}
            </h6>
          </div>
        </div>
      </div>

      <div class="border border-1 p-3 rounded mt-3 mc-notification-item">
        <div class="row mb-3">
          <div class="col-md-6 mt-3"></div>
          <div class="col-md-6 align-self-end">
            <div class="float-end mt-3">
              <div class="row">
                <div class="col-auto">
                  <div class="d-flex align-tems-center">
                    <i class="mc-fa icon-outline_message-square" style="font-size: 20px"></i>
                    <span class="ps-2">{{ $t('notification.text.popup') }}</span>
                  </div>
                </div>
                <div v-if="hasAccess(['sound_notification:update'])" class="col-auto">
                  <div class="d-flex align-tems-center">
                    <i class="mc-fa icon-outline_bell" style="font-size: 20px"></i>
                    <span class="ps-2">{{ $t('notification.text.sound') }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 mt-3">
            <h6>{{ $t('global.alert.suddenAcceleration') }}</h6>
          </div>
          <div class="col-md-6 align-self-end">
            <div class="float-end mt-3">
              <div class="row">
                <div class="col-auto me-3">
                  <div class="form-check form-switch form-switch-md mb-3">
                    <input
                      v-model="cekNonaktifDriverBehavior.acceleration"
                      class="form-check-input"
                      type="checkbox"
                      @change="checkSoundValueDriverBehavior('acceleration')"
                    />
                  </div>
                </div>
                <div v-if="hasAccess(['sound_notification:update'])" class="col-auto me-1">
                  <div class="form-check form-switch form-switch-md mb-3">
                    <input
                      v-model="cekNonaktifSoundDriverBehavior.acceleration"
                      class="form-check-input"
                      type="checkbox"
                      :disabled="!cekNonaktifDriverBehavior.acceleration"
                      @change="
                        changeState(
                          'cekNonaktifSoundDriverBehavior.acceleration',
                          cekNonaktifSoundDriverBehavior.acceleration
                        )
                      "
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6 mt-3">
            <h6>{{ $t('global.alert.suddenDeceleration') }}</h6>
          </div>
          <div class="col-md-6 align-self-end">
            <div class="float-end mt-3">
              <div class="row">
                <div class="col-auto me-3">
                  <div class="form-check form-switch form-switch-md mb-3">
                    <input
                      v-model="cekNonaktifDriverBehavior.deceleration"
                      class="form-check-input"
                      type="checkbox"
                      @change="checkSoundValueDriverBehavior('deceleration')"
                    />
                  </div>
                </div>
                <div v-if="hasAccess(['sound_notification:update'])" class="col-auto me-1">
                  <div class="form-check form-switch form-switch-md mb-3">
                    <input
                      v-model="cekNonaktifSoundDriverBehavior.deceleration"
                      class="form-check-input"
                      type="checkbox"
                      :disabled="!cekNonaktifDriverBehavior.deceleration"
                      @change="changeState('cekNonaktifSoundDriverBehavior.deceleration')"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6 mt-3">
            <h6>{{ $t('global.alert.overspeed') }}</h6>
          </div>
          <div class="col-md-6 align-self-end">
            <div class="float-end mt-3">
              <div class="row">
                <div class="col-auto me-3">
                  <div class="form-check form-switch form-switch-md mb-3">
                    <input
                      v-model="cekNonaktifDriverBehavior.speed"
                      class="form-check-input"
                      type="checkbox"
                      @change="checkSoundValueDriverBehavior('speed')"
                    />
                  </div>
                </div>
                <div v-if="hasAccess(['sound_notification:update'])" class="col-auto me-1">
                  <div class="form-check form-switch form-switch-md mb-3">
                    <input
                      v-model="cekNonaktifSoundDriverBehavior.speed"
                      class="form-check-input"
                      type="checkbox"
                      :disabled="!cekNonaktifDriverBehavior.speed"
                      @change="changeState('cekNonaktifSoundDriverBehavior.speed')"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6 mt-3">
            <h6>{{ $t('global.alert.sharpTurn') }}</h6>
          </div>
          <div class="col-md-6 align-self-end">
            <div class="float-end mt-3">
              <div class="row">
                <div class="col-auto me-3">
                  <div class="form-check form-switch form-switch-md mb-3">
                    <input
                      v-model="cekNonaktifDriverBehavior.turn"
                      class="form-check-input"
                      type="checkbox"
                      @change="checkSoundValueDriverBehavior('turn')"
                    />
                  </div>
                </div>
                <div v-if="hasAccess(['sound_notification:update'])" class="col-auto me-1">
                  <div class="form-check form-switch form-switch-md mb-3">
                    <input
                      v-model="cekNonaktifSoundDriverBehavior.turn"
                      class="form-check-input"
                      type="checkbox"
                      :disabled="!cekNonaktifDriverBehavior.turn"
                      @change="changeState('cekNonaktifSoundDriverBehavior.turn')"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="
          hasAccessAll([
            'raw_alerts_dms:read',
            'e1c-web-dms:read',
            'e2a-popup-notifikasi:create',
            'e2a-popup-notifikasi:read',
          ])
        "
        class="row"
      >
        <div class="col-md-6 mt-4">
          <h5 class="card-title">
            {{ 'DMS' }}
          </h5>
        </div>
        <div class="col-md-6 align-self-end">
          <div class="float-end mt-4">
            <h6 v-if="!isCheckAllDms" class="text-primary" @click="checkAllDms(true)">
              {{ $t('global.action.activate') }}
            </h6>
            <h6 v-else class="text-primary" @click="checkAllDms(false)">
              {{ $t('global.action.nonactivate') }}
            </h6>
          </div>
        </div>
      </div>

      <div class="border border-1 p-3 rounded mt-3 mc-notification-item">
        <div class="row mb-3">
          <div class="col-md-6 mt-3"></div>
          <div class="col-md-6 align-self-end">
            <div class="float-end mt-3">
              <div class="row">
                <div class="col-auto">
                  <div class="d-flex align-tems-center">
                    <i class="mc-fa icon-outline_message-square" style="font-size: 20px"></i>
                    <span class="ps-2">{{ $t('notification.text.popup') }}</span>
                  </div>
                </div>
                <div v-if="hasAccess(['sound_notification:update'])" class="col-auto">
                  <div class="d-flex align-tems-center">
                    <i class="mc-fa icon-outline_bell" style="font-size: 20px"></i>
                    <span class="ps-2">{{ $t('notification.text.sound') }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6 mt-3">
            <h6>{{ $t('notification.field.sleepy') }}</h6>
          </div>
          <div class="col-md-6 align-self-end">
            <div class="float-end mt-3">
              <div class="row">
                <div class="col-auto me-3">
                  <div class="form-check form-switch form-switch-md mb-3">
                    <input
                      v-model="cekNonaktifDms.yawn"
                      class="form-check-input"
                      type="checkbox"
                      @change="checkSoundValueDms('yawn')"
                    />
                  </div>
                </div>
                <div v-if="hasAccess(['sound_notification:update'])" class="col-auto me-1">
                  <div class="form-check form-switch form-switch-md mb-3">
                    <input
                      v-model="cekNonaktifSoundDms.yawn"
                      class="form-check-input"
                      type="checkbox"
                      :disabled="!cekNonaktifDms.yawn"
                      @change="toSave"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6 mt-3">
            <h6>{{ $t('notification.field.distracted') }}</h6>
          </div>
          <div class="col-md-6 align-self-end">
            <div class="float-end mt-3">
              <div class="row">
                <div class="col-auto me-3">
                  <div class="form-check form-switch form-switch-md mb-3">
                    <input
                      v-model="cekNonaktifDms.distraction"
                      class="form-check-input"
                      type="checkbox"
                      @change="checkSoundValueDms('distraction')"
                    />
                  </div>
                </div>
                <div v-if="hasAccess(['sound_notification:update'])" class="col-auto me-1">
                  <div class="form-check form-switch form-switch-md mb-3">
                    <input
                      v-model="cekNonaktifSoundDms.distraction"
                      class="form-check-input"
                      type="checkbox"
                      :disabled="!cekNonaktifDms.distraction"
                      @change="toSave"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6 mt-3">
            <h6>{{ $t('global.alert.smoking') }}</h6>
          </div>
          <div class="col-md-6 align-self-end">
            <div class="float-end mt-3">
              <div class="row">
                <div class="col-auto me-3">
                  <div class="form-check form-switch form-switch-md mb-3">
                    <input
                      v-model="cekNonaktifDms.smoking"
                      class="form-check-input"
                      type="checkbox"
                      @change="checkSoundValueDms('smoking')"
                    />
                  </div>
                </div>
                <div v-if="hasAccess(['sound_notification:update'])" class="col-auto me-1">
                  <div class="form-check form-switch form-switch-md mb-3">
                    <input
                      v-model="cekNonaktifSoundDms.smoking"
                      class="form-check-input"
                      type="checkbox"
                      :disabled="!cekNonaktifDms.smoking"
                      @change="toSave"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6 mt-3">
            <h6>{{ $t('notification.field.calling') }}</h6>
          </div>
          <div class="col-md-6 align-self-end">
            <div class="float-end mt-3">
              <div class="row">
                <div class="col-auto me-3">
                  <div class="form-check form-switch form-switch-md mb-3">
                    <input
                      v-model="cekNonaktifDms.phoneCalling"
                      class="form-check-input"
                      type="checkbox"
                      @change="checkSoundValueDms('phoneCalling')"
                    />
                  </div>
                </div>
                <div v-if="hasAccess(['sound_notification:update'])" class="col-auto me-1">
                  <div class="form-check form-switch form-switch-md mb-3">
                    <input
                      v-model="cekNonaktifSoundDms.phoneCalling"
                      class="form-check-input"
                      type="checkbox"
                      :disabled="!cekNonaktifDms.phoneCalling"
                      @change="toSave"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6 mt-3">
            <h6>{{ $t('notification.field.eyesClosed') }}</h6>
          </div>
          <div class="col-md-6 align-self-end">
            <div class="float-end mt-3">
              <div class="row">
                <div class="col-auto me-3">
                  <div class="form-check form-switch form-switch-md mb-3">
                    <input
                      v-model="cekNonaktifDms.eyeClosed"
                      class="form-check-input"
                      type="checkbox"
                      @change="checkSoundValueDms('eyeClosed')"
                    />
                  </div>
                </div>
                <div v-if="hasAccess(['sound_notification:update'])" class="col-auto me-1">
                  <div class="form-check form-switch form-switch-md mb-3">
                    <input
                      v-model="cekNonaktifSoundDms.eyeClosed"
                      class="form-check-input"
                      type="checkbox"
                      :disabled="!cekNonaktifDms.eyeClosed"
                      @change="toSave"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6 mt-3">
            <h6>{{ $t('notification.field.invisible') }}</h6>
          </div>
          <div class="col-md-6 align-self-end">
            <div class="float-end mt-3">
              <div class="row">
                <div class="col-auto me-3">
                  <div class="form-check form-switch form-switch-md mb-3">
                    <input
                      v-model="cekNonaktifDms.missingFace"
                      class="form-check-input"
                      type="checkbox"
                      @change="checkSoundValueDms('missingFace')"
                    />
                  </div>
                </div>
                <div v-if="hasAccess(['sound_notification:update'])" class="col-auto me-1">
                  <div class="form-check form-switch form-switch-md mb-3">
                    <input
                      v-model="cekNonaktifSoundDms.missingFace"
                      class="form-check-input"
                      type="checkbox"
                      :disabled="!cekNonaktifDms.missingFace"
                      @change="toSave"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6 mt-3">
            <h6>{{ $t('global.alert.crash') }}</h6>
          </div>
          <div class="col-md-6 align-self-end">
            <div class="float-end mt-3">
              <div class="row">
                <div class="col-auto me-3">
                  <div class="form-check form-switch form-switch-md mb-3">
                    <input
                      v-model="cekNonaktifDms.crash"
                      class="form-check-input"
                      type="checkbox"
                      @change="checkSoundValueDms('crash')"
                    />
                  </div>
                </div>
                <div v-if="hasAccess(['sound_notification:update'])" class="col-auto me-1">
                  <div class="form-check form-switch form-switch-md mb-3">
                    <input
                      v-model="cekNonaktifSoundDms.crash"
                      class="form-check-input"
                      type="checkbox"
                      :disabled="!cekNonaktifDms.crash"
                      @change="toSave"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="hasAccess(['seat_belt_alert:read'])" class="row">
          <div class="col-md-6 mt-3">
            <h6>{{ $t('global.alert.seatbelt') }}</h6>
          </div>
          <div class="col-md-6 align-self-end">
            <div class="float-end mt-3">
              <div class="row">
                <div class="col-auto me-3">
                  <div class="form-check form-switch form-switch-md mb-3">
                    <input
                      v-model="cekNonaktifDms.seatbelt"
                      class="form-check-input"
                      type="checkbox"
                      @change="checkSoundValueDms('seatbelt')"
                    />
                  </div>
                </div>
                <div v-if="hasAccess(['sound_notification:update'])" class="col-auto me-1">
                  <div class="form-check form-switch form-switch-md mb-3">
                    <input
                      v-model="cekNonaktifSoundDms.seatbelt"
                      class="form-check-input"
                      type="checkbox"
                      :disabled="!cekNonaktifDms.seatbelt"
                      @change="toSave"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="hasAccess(['fatigue_driving_alert:read'])" class="row">
          <div class="col-md-6 mt-3">
            <h6>{{ $t('global.alert.fatigueDriving') }}</h6>
          </div>
          <div class="col-md-6 align-self-end">
            <div class="float-end mt-3">
              <div class="row">
                <div class="col-auto me-3">
                  <div class="form-check form-switch form-switch-md mb-3">
                    <input
                      v-model="cekNonaktifDms.fatigueDriving"
                      class="form-check-input"
                      type="checkbox"
                      @change="checkSoundValueDms('fatigueDriving')"
                    />
                  </div>
                </div>
                <div v-if="hasAccess(['sound_notification:update'])" class="col-auto me-1">
                  <div class="form-check form-switch form-switch-md mb-3">
                    <input
                      v-model="cekNonaktifSoundDms.fatigueDriving"
                      class="form-check-input"
                      type="checkbox"
                      :disabled="!cekNonaktifDms.fatigueDriving"
                      @change="toSave"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="hasAccess(['infrared_blocked_alert:read'])" class="row">
          <div class="col-md-6 mt-3">
            <h6>{{ $t('global.alert.infraredBlocked') }}</h6>
          </div>
          <div class="col-md-6 align-self-end">
            <div class="float-end mt-3">
              <div class="row">
                <div class="col-auto me-3">
                  <div class="form-check form-switch form-switch-md mb-3">
                    <input
                      v-model="cekNonaktifDms.infraredBlocked"
                      class="form-check-input"
                      type="checkbox"
                      @change="checkSoundValueDms('infraredBlocked')"
                    />
                  </div>
                </div>
                <div v-if="hasAccess(['sound_notification:update'])" class="col-auto me-1">
                  <div class="form-check form-switch form-switch-md mb-3">
                    <input
                      v-model="cekNonaktifSoundDms.infraredBlocked"
                      class="form-check-input"
                      type="checkbox"
                      :disabled="!cekNonaktifDms.infraredBlocked"
                      @change="toSave"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="
          hasAccessAll([
            'raw_alerts_umum:read',
            'e1b-web-umum:read',
            'e2a-popup-notifikasi:create',
            'e2a-popup-notifikasi:read',
          ])
        "
        class="row"
      >
        <div class="col-md-6 mt-4">
          <h5 class="card-title">
            {{ $t('global.object.general') }}
          </h5>
        </div>
        <div class="col-md-6 align-self-end">
          <div class="float-end mt-4">
            <h6 v-if="!isCheckAllGeneral" class="text-primary" @click="checkAllGeneral(true)">
              {{ $t('global.action.activate') }}
            </h6>
            <h6 v-else class="text-primary" @click="checkAllGeneral(false)">
              {{ $t('global.action.nonactivate') }}
            </h6>
          </div>
        </div>
      </div>

      <div class="border border-1 p-3 rounded mt-3 mc-notification-item">
        <div class="row mb-3">
          <div class="col-md-6 mt-3"></div>
          <div class="col-md-6 align-self-end">
            <div class="float-end mt-3">
              <div class="row">
                <div class="col-auto">
                  <div class="d-flex align-tems-center">
                    <i class="mc-fa icon-outline_message-square" style="font-size: 20px"></i>
                    <span class="ps-2">{{ $t('notification.text.popup') }}</span>
                  </div>
                </div>
                <div v-if="hasAccess(['sound_notification:update'])" class="col-auto">
                  <div class="d-flex align-tems-center">
                    <i class="mc-fa icon-outline_bell" style="font-size: 20px"></i>
                    <span class="ps-2">{{ $t('notification.text.sound') }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-for="general in listGeneral" :key="`row-${general.model}`">
          <div v-if="general.scope == null ? true : general.scope" class="row">
            <div class="col-md-6 mt-3">
              <h6>{{ general.title }}</h6>
            </div>
            <div class="col-md-6 align-self-end">
              <div class="float-end mt-3">
                <div class="row">
                  <div class="col-auto me-3">
                    <div class="form-check form-switch form-switch-md mb-3">
                      <input
                        v-model="cekNonaktifGeneral[general.model]"
                        class="form-check-input"
                        type="checkbox"
                        @change="checkSoundValueGeneral(general.model)"
                      />
                    </div>
                  </div>
                  <div v-if="hasAccess(['sound_notification:update'])" class="col-auto me-1">
                    <div class="form-check form-switch form-switch-md mb-3">
                      <input
                        v-model="cekNonaktifSoundGeneral[general.modelSound]"
                        class="form-check-input"
                        type="checkbox"
                        :disabled="!cekNonaktifGeneral[general.model]"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="
          hasAccessAll([
            'raw_alerts_adas:read',
            'e1g-web-adas:read',
            'e2a-popup-notifikasi:create',
            'e2a-popup-notifikasi:read',
          ])
        "
        class="row"
      >
        <div class="col-md-6 mt-4">
          <h5 class="card-title">
            {{ 'ADAS' }}
          </h5>
        </div>
        <div class="col-md-6 align-self-end">
          <div class="float-end mt-4">
            <h6 v-if="!isCheckAllAdas" class="text-primary" @click="checkAllAdas(true)">
              {{ $t('global.action.activate') }}
            </h6>
            <h6 v-else class="text-primary" @click="checkAllAdas(false)">
              {{ $t('global.action.nonactivate') }}
            </h6>
          </div>
        </div>
      </div>

      <div
        v-if="hasAccess(['e1g-web-adas:read'])"
        class="border border-1 p-3 rounded mt-3 mc-notification-item"
      >
        <div class="row mb-3">
          <div class="col-md-6 mt-3"></div>
          <div class="col-md-6 align-self-end">
            <div class="float-end mt-3">
              <div class="row">
                <div class="col-auto">
                  <div class="d-flex align-tems-center">
                    <i class="mc-fa icon-outline_message-square" style="font-size: 20px"></i>
                    <span class="ps-2">{{ $t('notification.text.popup') }}</span>
                  </div>
                </div>
                <div v-if="hasAccess(['sound_notification:update'])" class="col-auto">
                  <div class="d-flex align-tems-center">
                    <i class="mc-fa icon-outline_bell" style="font-size: 20px"></i>
                    <span class="ps-2">{{ $t('notification.text.sound') }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-for="adas in listAdas" :key="`row-${adas.model}`">
          <div v-if="adas.scope == null ? true : adas.scope" class="row">
            <div class="col-md-6 mt-3">
              <h6>{{ adas.title }}</h6>
            </div>
            <div class="col-md-6 align-self-end">
              <div class="float-end mt-3">
                <div class="row">
                  <div class="col-auto me-3">
                    <div class="form-check form-switch form-switch-md mb-3">
                      <input
                        v-model="cekNonaktifAdas[adas.model]"
                        class="form-check-input"
                        type="checkbox"
                        @change="checkSoundValueAdas(adas.model)"
                      />
                    </div>
                  </div>
                  <div v-if="hasAccess(['sound_notification:update'])" class="col-auto me-1">
                    <div class="form-check form-switch form-switch-md mb-3">
                      <input
                        v-model="cekNonaktifSoundAdas[adas.modelSound]"
                        class="form-check-input"
                        type="checkbox"
                        :disabled="!cekNonaktifAdas[adas.model]"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-tab>
</template>
